module.exports = __webpack_public_path__ + "static/media/archibot-grosse-bouche.b9fb46c4.gif";